module.exports = __webpack_public_path__ + "static/media/footage_icon.3b988d07.svg";